import React from "react";
import { Route, Switch } from "react-router-dom";
import FaleConosco from "./pages/FaleConosco";

import "./assets/fale-conosco.scss";

const FaleConoscoPage: React.FC = () => {
  return (
    <Switch>
      <Route
        path="/fale-conosco/inicio"
        exact={true}
        component={FaleConosco}
      />
    </Switch>
  );
};

export default FaleConoscoPage;
